import React, {memo} from 'react';
import {Box, Tooltip, Typography,} from '@material-ui/core';
import MaterialTable from 'material-table';
import TableIcons from '../../utils/TableIcons';

import LaunchIcon from '@material-ui/icons/Launch';
import RefreshIcon from '@material-ui/icons/Refresh';
import {ActiveState, getStateName} from "../../utils/ActiveState";
import setActiveIconWithPaused from "../../utils/setActiveIconWithPaused";

const ServicersTable = memo(({data, refetch}) => {
    const brandBox = (data, label) => (
        <Box style={{marginBottom: '5px'}}>
            <Typography variant="body2">
                <strong>{label}:</strong> {data}
            </Typography>
        </Box>
    );

    const activeStateLookup = [
        {id: ActiveState.ACTIVE, title: 'Active'},
        {id: ActiveState.PAUSED, title: 'Paused'},
        {id: ActiveState.INACTIVE, title: 'Not Active'},
    ]

    const lookupState = {}
    activeStateLookup.map(row => {
        lookupState[row.id] = row.title
    })

    return (
        <MaterialTable
            title=""
            icons={TableIcons}
            columns={[{
                title: 'Id', field: "id",
            }, {
                title: 'Active',
                field: "activeState",
                lookup: lookupState,
                defaultFilter: [String(ActiveState.ACTIVE), String(ActiveState.PAUSED)],
                render: (rowData) => {
                    return (<Tooltip title={getStateName(rowData.activeState)}>
                        {setActiveIconWithPaused(rowData.activeState)}
                    </Tooltip>)
                }
            }, {
                title: 'Name', field: "name",
            }, {
                title: 'Email', field: "email"
            }, {
                title: 'Phone', field: 'phone'
            }, {
                title: 'Website', field: 'website'
            }, {
                title: 'Branding Contact Info', field: 'brandingContactInformation',
                render: rowData => {
                    const {brandingContactInformation} = rowData;
                    if (!brandingContactInformation) {
                        return (
                            <Box>
                                N/A
                            </Box>
                        );
                    }
                    ;
                    const {name, email, phone, website} = brandingContactInformation;
                    return (
                        <Box display="flex" alignItems="flex-start" justifyContent="space-between"
                             flexDirection="column">
                            {brandBox(name, 'name')}
                            {brandBox(email, 'email')}
                            {brandBox(phone, 'phone')}
                            {brandBox(website, 'website')}
                        </Box>
                    );
                }
            }, {
                title: 'Choice Of Law', field: 'choiceOfLaw'
            }]}
            data={data.map(servicer => ({
                id: servicer.id,
                activeState: servicer.activeState,
                active: servicer.active,
                name: servicer.name || 'N/A',
                email: servicer.email || 'N/A',
                phone: servicer.phone || 'N/A',
                website: servicer.website || 'N/A',
                brandingContactInformation: servicer.brandingContactInformation,
                choiceOfLaw: servicer.choiceOfLaw || 'N/A'
            }))}
            actions={[
                {
                    icon: () => <RefreshIcon/>,
                    tooltip: 'Refetch Data',
                    isFreeAction: true,
                    onClick: (event) => refetch()
                },
                {
                    icon: () => <LaunchIcon/>,
                    tooltip: 'View Servicer',
                    onClick: (event, rowData) => window.open(`/info/servicers/${rowData.id}`)
                },
            ]}
            options={{
                pageSize: 20,
                filtering: true,
                pageSizeOptions: [20, 50, 100],
            }}
        />
    );
});

export default ServicersTable;
